export default __webpack_public_path__ + "static/media/9.ae6f75a0.jpg";